import OrderEmissionServices from "../../services/OrderEmissionServices";
const state = {
    loadingOrderEmission: false,
    identificationTypes: ["CEDULA", "RUC", "EXTRANJERA", "PASAPORTE"],
    mailToSendForm: ["Cliente", "APS", "Otro"],
    typesCollectPromissoryNoteWithBankDebit: ["Si", "No"],
    ordersEmissionPaging: [],
    brokerProfile:undefined,
    paginationOrderEmission: {
        descending: true,
        page: 1,
        rowsPerPage: 20,
        sortBy: 'cotizationDate',
        totalItems: 0,
        rowsPerPageItems: [10, 20, 50, 100]
    },
    trueFalseOptions:[
        {value: "", text: 'Seleccione'},
        {value: "true", text: 'Si'},
        {value: "false", text: 'No'}
      ],
      catalogsMultiriesgoProducts: ["Multiriesgo Pymes", "Multiriesgo Industrial "],
      catalogsMultiriesgoProductsTecny: ["Multiriesgo Pymes", "Multiriesgo Industrial ", "Tecnipymes"]
};

const getters = {
    loadingOrderEmission: state => {
        return state.loadingOrderEmission;
    },
    identificationTypes: state => {
        return state.identificationTypes;
    },
    mailToSendForm: state => {
        return state.mailToSendForm;
    },
    typesCollectPromissoryNoteWithBankDebit: state => {
        return state.typesCollectPromissoryNoteWithBankDebit;
    },


    ordersEmissionPaging: state => {
        return state.ordersEmissionPaging;
    },
    paginationOrderEmission(state) {
        return state.paginationOrderEmission
    },
    trueFalseOptions: state => {
        return state.trueFalseOptions
    },
    catalogsMultiriesgoProducts: state => {
        return state.catalogsMultiriesgoProducts
    },
    catalogsMultiriesgoProductsTecny: state => {
        return state.catalogsMultiriesgoProductsTecny
    },
    brokerProfile: state => {
        return state.brokerProfile;
    },     
};

const actions = {
    queryOrderEmission(context, filters) {
        context.commit("showLoadingOrderEmissionIndicator");
        const {
            sortBy,
            descending,
            page,
            rowsPerPage
        } = context.state.paginationOrderEmission
        const scopes = context.rootGetters.userScopes;
        const agencyId= context.rootGetters.agencyId;
        const profile = context.rootGetters.userProfile;
        console.log(context.rootGetters);
        const business_name_executive = context.rootGetters.business_name_executive;


        filters.usuarioCreadorId = profile.user_id;
        let nombreCompleto = 
        context.rootGetters.userProfile.first_name + " " +
        context.rootGetters.userProfile.second_name + " " +
        context.rootGetters.userProfile.first_surname + " " + 
        context.rootGetters.userProfile.second_surname ;

        filters.usuarioCreadorName = nombreCompleto;
        filters.identificacion = profile.identity;

        return OrderEmissionServices.queryOrders(page, rowsPerPage, filters, scopes,profile,agencyId,business_name_executive)
            .then((res) => {
                if (res.data.error == 0) {
                    const items = res.data.data.content;
                    const totalItems = res.data.data.total;
                    context.commit('_setOrderEmissionPaging', {
                        items,
                        totalItems
                    })
                } else {
                    const items = [];
                    const totalItems = 0;
                    context.commit('_setOrderEmissionPaging', {
                        items,
                        totalItems
                    })
                }
            })
            .catch(() => {

            })
            .finally(() => {
                context.commit("hideLoadingOrderEmissionIndicator");
            });
    },
    searchOrderEmission(context, filters) {       
        const {
            sortBy,
            descending,
            page,
            rowsPerPage
        } = context.state.paginationOrderEmission
        const profile = context.rootGetters.userProfile;
        const agencyId= context.rootGetters.agencyId;
        const scopes = context.rootGetters.userScopes;
        const business_name_executive = context.rootGetters.business_name_executive;
        return OrderEmissionServices.queryOrders(page, rowsPerPage, filters, scopes, profile,agencyId,business_name_executive)
            .then((res) => {
                if (res.data.error == 0) {
                    const items = res.data.data.content;
                    const totalItems = res.data.data.total;
                    context.commit('_setOrderEmissionPaging', {
                        items,
                        totalItems
                    })
                } else {
                    const items = [];
                    const totalItems = 0;
                    context.commit('_setOrderEmissionPaging', {
                        items,
                        totalItems
                    })
                }
            })
            .catch(() => {

            })
            .finally(() => {
                /*   context.commit("hideLoadingOrderEmissionIndicator"); */
            });
    },
    searchBrokerByUserId(context, userId) {  
        return OrderEmissionServices.searchBrokerByUserId(userId)
        .then((respuesta) => {
            context.commit("mSetBrokerSiaerp",respuesta.data);

        })
        .catch(() => {

        })
        .finally(() => {
            /*   context.commit("hideLoadingOrderEmissionIndicator"); */
        });
    },
};

const mutations = {
    showLoadingOrderEmissionIndicator(state) {
        state.loadingOrderEmission = true;
    },
    hideLoadingOrderEmissionIndicator(state) {
        state.loadingOrderEmission = false;
    },
    mSetBrokerSiaerp(state,data){
        state.brokerProfile = data;
        
    },

    setPaginationOrderEmission(state, payload) {
        state.paginationOrderEmission = payload
    },
    _setOrderEmissionPaging(state, {
        items,
        totalItems
    }) {
        state.ordersEmissionPaging = items
        state.paginationOrderEmission.totalItems = totalItems
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};